var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('CFlex',{attrs:{"w":"100%","direction":"column","align":"center","h":"100vh"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }